import { render, staticRenderFns } from "./activationMobile.vue?vue&type=template&id=19fbcb24&scoped=true&"
import script from "./activationMobile.vue?vue&type=script&lang=js&"
export * from "./activationMobile.vue?vue&type=script&lang=js&"
import style0 from "./activationMobile.vue?vue&type=style&index=0&id=19fbcb24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fbcb24",
  null
  
)

export default component.exports